module.exports = __webpack_public_path__ + "img/cdiscount.4d48994b.png";